{
	"pixKeyLabel": "Clé PIX",
	"pixTypeLabel": "Type de Clé PIX",
	"pixTypePlaceholder": "Sélectionnez le type de Clé PIX",
	"defaultPlaceholder": "Saisissez clé PIX",
	"copyPastePlaceholder": "Collez votre clé PIX",
	"placeholders": {
		"phone": "(41) 99999-9999",
		"cpf": "000.000.000-00",
		"cnpj": "00.000.000/0000-00",
		"email": "exemple@email.com",
		"evp": "Clé aléatoire"
	},
	"pixKeyType": {
		"random": "Aléatoire",
		"phone": "Téléphone",
		"copyPaste": "Copier et Coller"
	},
	"validation": {
		"invalidPixKey": "Clé PIX invalide"
	}
}
